import { useState } from 'react'
import { Box, Menu, MenuItem } from '@mui/material'
import { colors } from '../../const/colors'

export interface FilterPillOption {
  value: string
  label: string
}

interface FilterPillProps {
  label: string
  value: string
  options: FilterPillOption[]
  onSelect: (value: string) => void
  e2e?: string
}

export function FilterPill({ label, value, options, onSelect, e2e }: FilterPillProps) {
  const [anchor, setAnchor] = useState<null | HTMLElement>(null)
  const displayLabel = value
    ? options.find(option => option.value === value)?.label || label
    : label

  return (
    <>
      <Box
        onClick={event => setAnchor(event.currentTarget)}
        data-e2e={e2e}
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          height: 48,
          px: '18px',
          borderRadius: colors.radiusPill,
          background: colors.surface,
          border: `1px solid ${value ? colors.navy : colors.border3}`,
          fontSize: '14px',
          color: value ? colors.navy : colors.textSecondary,
          fontWeight: 600,
          cursor: 'pointer',
          whiteSpace: 'nowrap',
          transition: 'border-color .15s',
          '&:hover': { borderColor: colors.slateLight },
        }}
      >
        {displayLabel}
        <Box
          component="span"
          sx={{
            color: colors.slateLight,
            fontSize: '11px',
            lineHeight: 1,
            transform: anchor ? 'rotate(180deg)' : 'none',
            transition: 'transform .15s',
          }}
        >
          ▾
        </Box>
      </Box>
      <Menu
        anchorEl={anchor}
        open={!!anchor}
        onClose={() => setAnchor(null)}
        slotProps={{
          paper: {
            sx: {
              borderRadius: '14px',
              boxShadow: colors.shadowCard,
              border: `1px solid ${colors.border}`,
              mt: 0.5,
              minWidth: 180,
            },
          },
        }}
      >
        {options.map(option => (
          <MenuItem
            key={option.value}
            selected={option.value === value}
            onClick={() => {
              onSelect(option.value)
              setAnchor(null)
            }}
            sx={{
              fontSize: '14px',
              fontWeight: option.value === value ? 700 : 400,
              color: option.value === value ? colors.navy : colors.textBody,
            }}
          >
            {option.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}
